/*
 *
 * SendDirectlyPopup
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 21-Jan-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  smsTitle: <PortalMessage id='t.app.payByLink.successPage.popUp.sms' defaultMessage='Send Direct SMS' />,
  emailTitle: <PortalMessage id='t.app.payByLink.successPage.popUp.email' defaultMessage='Send Direct Email' />,
  exportDescription: (
    <PortalMessage id='t.app.payByLink.successPage.popUp.subTitle' defaultMessage='Please confirm your details:' />
  ),
  confirm: <PortalMessage id='t.app.project.btn.confirm' defaultMessage='Confirm' />,
  cancel: <PortalMessage id='t.app.project.btn.cancel' defaultMessage='Cancel' />,
  language: <PortalMessage id='t.app.paybylink.request.popUp.language' defaultMessage='Language' />,
  email: <PortalMessage id='t.app.paybylink.request.popUp.email' defaultMessage='Email Address*' />
}

export const captions = defineMessages({
  languageAriaLabel: {
    id: 't.app.accessibility.paybylink.request.popUp.language.ariaLabel',
    defaultMessage: 'Language'
  },
  languagePlaceholder: {
    id: 't.app.paybylink.request.language.placeholder',
    defaultMessage: 'Select language'
  },
  mobileNumber: {
    id: 't.app.paybylink.request.popUp.mobileNumber',
    defaultMessage: 'Mobile Number*'
  },
  countryCode: {
    id: 't.app.paybylink.request.popUp.countryCode',
    defaultMessage: 'Country Code*'
  },
  select: {
    id: 't.app.project.placeholder.select',
    defaultMessage: 'Select'
  },
  enterNumber: {
    id: 't.app.project.placeholder.enterNumber',
    defaultMessage: 'Enter number'
  },
  validPhoneNumber: {
    id: 't.app.paybylink.request.other.info.validator.phoneNumber',
    defaultMessage: 'it is a numeric field and can be between 6 and 15 digits.'
  },
  validEmail: {
    id: 't.app.paybylink.request.validator.validEmail',
    defaultMessage: 'Enter a valid email'
  },
  isRequired: {
    id: 't.app.project.error.isRequired',
    defaultMessage: 'This field is required'
  },
  close: {
    id: 't.app.accessibility.project.btn.close.ariaLabel',
    defaultMessage: 'Close'
  },
  email: {
    id: 't.app.paybylink.request.popUp.email',
    defaultMessage: 'Email Address*'
  }
})

export const lang = defineMessages({
  bs: {
    id: 't.app.paybylink.request.bs',
    defaultMessage: 'Bosnian'
  },
  it: {
    id: 't.app.paybylink.request.it',
    defaultMessage: 'Italian'
  },
  en: {
    id: 't.app.paybylink.request.en',
    defaultMessage: 'English'
  },
  el: {
    id: 't.app.paybylink.request.el',
    defaultMessage: 'Greek'
  },
  es: {
    id: 't.app.paybylink.request.es',
    defaultMessage: 'Spanish'
  },
  de: {
    id: 't.app.paybylink.request.de',
    defaultMessage: 'German'
  },
  fr: {
    id: 't.app.paybylink.request.fr',
    defaultMessage: 'French'
  },
  pt: {
    id: 't.app.paybylink.request.pt',
    defaultMessage: 'Portuguese'
  },
  ja: {
    id: 't.app.paybylink.request.ja',
    defaultMessage: 'Japanese'
  },
  ar: {
    id: 't.app.paybylink.request.ar',
    defaultMessage: 'Arabic'
  },
  ru: {
    id: 't.app.paybylink.request.ru',
    defaultMessage: 'Russian'
  },
  zh: {
    id: 't.app.paybylink.request.zh',
    defaultMessage: 'Chinese'
  },
  cs: {
    id: 't.app.paybylink.request.cs',
    defaultMessage: 'Czech'
  },
  hu: {
    id: 't.app.paybylink.request.hu',
    defaultMessage: 'Hungarian'
  },
  sk: {
    id: 't.app.paybylink.request.sk',
    defaultMessage: 'Slovak'
  },
  sl: {
    id: 't.app.paybylink.request.sl',
    defaultMessage: 'Slovenian'
  },
  sq: {
    id: 't.app.paybylink.request.sq',
    defaultMessage: 'Albanian'
  },
  sr: {
    id: 't.app.paybylink.request.sr',
    defaultMessage: 'Serbian'
  },
  ro: {
    id: 't.app.paybylink.request.ro',
    defaultMessage: 'Romanian'
  },
  pl: {
    id: 't.app.paybylink.request.pl',
    defaultMessage: 'Polish'
  },
  hr: {
    id: 't.app.paybylink.request.hr',
    defaultMessage: 'Croatian'
  }
})

export const messages = {
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  }
}

export default formattedMessage
